var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("delegation.delegationNew.title")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "v-row",
          {
            staticClass: "text-center justyfy-center",
            attrs: { "align-content": "center", align: "center" }
          },
          [
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5",
                attrs: { cols: "12", lg: "4" }
              },
              [
                _c("h3", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("delegation.delegationNew.independent")) +
                      " "
                  )
                ]),
                _c(
                  "v-icon",
                  {
                    staticClass: "font-weight-regular",
                    attrs: { size: "150px" }
                  },
                  [_vm._v("fa-calendar-plus")]
                ),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "delegation.delegationNew.independentDescription"
                        )
                      ) +
                      " "
                  )
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { bottom: "" },
                    on: {
                      click: function($event) {
                        return _vm.choseEmpty()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5",
                attrs: { cols: "12", lg: "4" }
              },
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("delegation.delegationNew.basedOnDelegationOrder")
                    )
                  )
                ]),
                _c(
                  "v-icon",
                  {
                    staticClass: "font-weight-regular",
                    attrs: { size: "150px" }
                  },
                  [_vm._v("fa-calendar-check")]
                ),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "delegation.delegationNew.basedOnDelegationOrderDescription"
                        )
                      ) +
                      " "
                  )
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { bottom: "" },
                    on: {
                      click: function($event) {
                        return _vm.choseBasedOnOrder()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }